import { useContext } from 'react';
import LoadingPlaceholder, { LoaderType } from 'shared/components/loading-placeholder';
import AiConversationContext, { AIRolePlayStatus, MessageStatus, Role } from './context';
import AiChat from './ai-chat';
import LearnerChat from './learner-chat';

const Chats = () => {
  const {
    messages,
    aiRolePlayStatus,
    openingNarrative,
    isAwaitingAiResponse,
  } = useContext(AiConversationContext);

  const lastMessage = messages[messages.length - 1];
  const isWaitingAfterLearnerMessage = lastMessage?.role === Role.LEARNER
    && (lastMessage?.status === MessageStatus.SENT || lastMessage?.status === MessageStatus.PENDING)
    && aiRolePlayStatus === AIRolePlayStatus.IN_PROGRESS;
  // Also show the typing indicator during the gap between the opening
  // narrative finishing (`done` event) and the first `delta` of the first
  // AI message arriving on the same SSE stream.
  const isWaitingForAiResponse = isWaitingAfterLearnerMessage
    || (isAwaitingAiResponse && aiRolePlayStatus === AIRolePlayStatus.IN_PROGRESS);

  return (
    <div className='d-flex flex-column'>
      {openingNarrative ? (
        <div className='w-100 mt-5'>
          {openingNarrative}
        </div>
      ) : (
        <LoadingPlaceholder
          loaderType={LoaderType.HALF}
          className='mt-5'
        />
      )}
      {
        messages.map((message) => {
          if (message.role === Role.AI) {
            return (
              <div key={message.id} className='w-100 mt-5'>
                <AiChat content={message.content} />
              </div>
            );
          }
          return (
            <div key={message.id} className='w-100 mt-5'>
              <LearnerChat content={message.content} />
            </div>
          );
        })
      }
      {
        isWaitingForAiResponse && (
          <div className='w-100 mt-5'>
            <AiChat isStreaming={isWaitingForAiResponse} />
          </div>
        )
      }
    </div>
  );
};

export default Chats;
